//
// DynamicReferenceContainer.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "./Dynamic";
import "./DynamicReference";

var DynamicReferenceContainer = createModule("gtl::DynamicReferenceContainer", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel","gtl::Dynamic"], EventDispatcher, [
    ,
    {
        references: [1],
    },
    ,
    ,
    {
        addReference: [0,1,7],
    },
    ,
    ,
]);
export default DynamicReferenceContainer;
